import { mapState } from 'vuex'
import moment from 'moment'
import AdditionalOrder from '@/mixins/additionalOrder.js'

export default {
  mixins: [AdditionalOrder],
  props: {
    checkExpireDate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showExpireDatePrompt: false,
    }
  },
  computed: {
    ...mapState({
      quoteExpireDate(state, getters) {
        return getters[this.quoteNamespace + '/expireDate']
      },
    }),
  },
  methods: {
    expireDateCheck() {
      if (this.checkExpireDate) {
        if (this.expireDateExpired() || this.expireDateTooBig()) {
          this.showExpireDatePrompt = true
          return false
        }
      }
      return true
    },
    expireDateExpired() {
      return moment.utc().isAfter(moment.utc(this.quoteExpireDate), 'day')
    },
    expireDateTooBig() {
      return moment.utc().add(30, 'days').isBefore(moment.utc(this.quoteExpireDate), 'day')
    },
  },
}
